import CityPageTemplate from "../city-template/CityPageTemplate";
import { richmondVaConfig } from "./data";

export default function RichmondVaPage() {
  return <CityPageTemplate config={richmondVaConfig} />;
}